"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotMoneyLoad = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotMoneyLoad = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#money_load_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20.083 12.857v14.286m3.247-11.689h-4.871a2.273 2.273 0 1 0 0 4.546h3.247a2.274 2.274 0 0 1 0 4.545h-5.52M27.142 5.053c.163.081.326.165.486.251m2.37 1.544c.065.05.129.101.192.152m1.952 1.843c.091.101.181.204.27.307m1.645 2.279c.08.133.158.267.234.402M35.664 15c.06.188.116.378.168.569m.535 3.002c.04.47.06.947.06 1.428 0 9.204-7.463 16.666-16.67 16.666-7.83 0-16.187-7.459-16.187-16.666S11.93 3.333 19.757 3.333c1.57 0 3.088.217 4.528.622"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "money_load_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotMoneyLoad = SpotMoneyLoad;
SpotMoneyLoad.displayName = "SpotMoneyLoad";